if (!customElements.get("auto-add-selling-plans")) {
  customElements.define(
    "auto-add-selling-plans",
    class AutoAddSellingPlans extends HTMLElement {
      attributes = ['data-changes'];

      connectedCallback() {
        this.fixSellingPlans();
      }
      // run when changes attribute is updated
      attributeChangedCallback(name) {
        if (name === 'data-changes') {
          this.fixSellingPlans();
        }
      }

      async fixSellingPlans() {
        const changes = JSON.parse(this.dataset.changes);
        if (!changes || changes.length === 0) {
          return;
        }
        const updateCartItem = async (index, quantity, sellingPlanId) => {
          try {
            const formData = new FormData();
            formData.append('line', index);
            formData.append('quantity', quantity);
            formData.append('selling_plan', sellingPlanId);
            const response = await fetch(window.Shopify.routes.root + `cart/change.js`, {
              method: 'POST',
              body: formData
            });
            const cartData = await response.json();
            return cartData;
          } catch (error) {
            console.error('error updating cart item', error);
          }
        }
        let cartData = null;
        for (let change of changes) {
          const [sellingPlanId, index, quantity] = change;
          if (!sellingPlanId) {
            continue;
          }
          cartData = await updateCartItem(index, quantity, sellingPlanId);
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'auto-add-selling-plans',
          cartData: cartData
        });
      }
    }
  );
}

